<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="MinusDrillHeightStyle" v-show="dataChart.length || !isDataCenter"></div>
    <noDataSvg :color="editorType === 1 ? '#787A80' : '#787A80'" v-if="!dataChart.length && isDataCenter"/>
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
    <Pagenation :thisArg="thisArg"></Pagenation>
  </div>
</template>

<script>
import util from "@/option/common/util";
import noDataSvg from './svg.vue'

export default {
  name: "mixBarNew",
  components: {
    noDataSvg: noDataSvg
  },
  data() {
    return {
      formatter: (params, data) => {
        let content = '';
        if (!this.option.tipContent) {
          this.option.tipContent = ['维度值', '指标名', '指标值']
        }
        if (this.option.tipContent?.includes('维度值')) {
          content += `<div>${params[0].name}</div>`
        }
        params.forEach(item => {
          content += '<div>'
          if (this.option.tipContent?.includes('指标名')) {
            content += `${item.seriesName}`
          }
          if (this.option.tipContent?.includes('指标值')) {
            if (this.option.tipContent?.includes('指标名')) {
              content += '：'
            }
            const unit = this.getUnit(item.seriesName)
            content += `${item.value}${unit}`
          }
          content += '</div>'
        })
        return content
      },
      labelFormatter: (params, data) => {
        let content = '';
        if (this.option.labelContent?.includes('维度值')) {
          content += `${params.name}`
        }
        if (this.option.labelContent?.includes('指标值')) {
          if (this.option.labelContent?.includes('维度值')) {
            content += '：'
          }
          const unit = this.getUnit(params.seriesName)
          content += `${params.value}${unit}`
        }
        return content
      }
    }
  },
  computed: {
    isView() {
      return this.$route.name === 'view'
    }
  },
  methods: {
    // 获取单位
    getUnit(name) {
      const fieldItem = (this.prop?.metrics || [...this.prop?.metricsR, ...this.prop?.metricsL])?.find(item => item.name === name || item.fieldName === name) || {}
      if (fieldItem?.set?.type === 'percent') {
        return '%'
      }
      return fieldItem?.set?.indexUnit || ''
    },
    getType(name) {
      const fieldItem = [...this.prop?.metricsR, ...this.prop?.metricsL]?.find(item => item.name === name || item.fieldName === name) || {}
      return fieldItem?.set?.seriesType || ''
    },
    updateChart() {
      const {
        chartSet: {
          axisLabelSet = {},
        },
        fontFamily = ''
      } = this.themeCfg
      const optionData = this.deepClone(this.dataChart);
      let option = {
        dataZoom: this.getDataZoom(),
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip({
          trigger: "axis",
          confine: true
        }),
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(),
        xAxis: this.getXAxisOption({
          data: optionData?.categories || [],
          boundaryGap: true,
          axisLabel: {
            show: this.validData(this.option.axisLabelShow, true),
            interval: this.option.xAxisInterval || 'auto',
            rotate: this.option.xAxisRotate || 0,
            textStyle: {
              color: this.option.xAxisColor || (axisLabelSet?.color || "#fff"),
              fontSize: this.option.xAxisFontSize || (axisLabelSet?.size || 14),
              fontFamily: this.option.xAxisFontFamily || fontFamily,
            }
          }
        }),
        yAxis: [
          this.getYAxisOption({
            min: this.option.yAxisMinAuto ? null : this.option.yAxisMin,
            max: this.option.yAxisMaxAuto ? null : this.option.yAxisMax,
            interval: this.option.yAxisIntervalAuto ? null : this.option.yAxisInterval,
            minInterval: this.option.yAxisminInterval,
          }),
          this.getRightYAxisOption({
            position: "right",
            min: this.option.rightAxisMinAuto ? null : this.option.rightAxisMin,
            max: this.option.rightAxisMaxAuto ? null : this.option.rightAxisMax,
            interval: this.option.rightAxisIntervalAuto ? null : this.option.rightAxisInterval,
            minInterval: this.option.rightAxisminInterval,
          })
        ],
        series: (() => {
          let list = (optionData?.series || []).filter((ele) => {
            return ele.type == "bar"
          }).map((ele, index) => {
            const defaultColor = this.getColor(index)
            return {
              ...ele, ...{
                type: "bar",
                stack: this.option.stack && ele.stack,
                barWidth: this.option.barWidth || 16,
                itemStyle: this.getHasProp(!this.switchTheme, {
                  color: defaultColor
                }, {barBorderRadius: this.option.barRadius || 0}),
                label: this.getOptionLabel({
                  position: this.option.labelPosition,
                })
              }
            };
          });
          const tmp = (optionData?.series || []).filter((ele) => {
            return ele.type == "line"
          }).map((ele, index) => {
            const defaultColor = this.getColor(optionData?.series.length - index)
            return {
              ...ele, ...{
                type: "line",
                yAxisIndex: 1,
                smooth: this.validData(this.option.smooth, true),
                showSymbol: this.validData(this.option.symbolShow, false),
                symbol: this.option.symbolKind,
                symbolSize: this.option.symbolSize || 10,
                areaStyle: (() => {
                  if (this.option.areaStyle) {
                    return {
                      opacity: 0.7
                    };
                  }
                })(),
                itemStyle: this.getHasProp(!this.switchTheme, {
                  color: defaultColor
                }, {barBorderRadius: this.option.barRadius || 0}),
                label: this.getOptionLabel({
                  position: this.option.labelPosition,
                }),
                labelLine: {
                  show: this.option.labelContent?.includes('引导线') || false
                },
                lineStyle: {
                  width: this.option.lineWidth || 1
                },
              }
            };
          })
          list = list.concat(tmp)
          return list;
        })()
      };
      if (this.isDataCenter) {
        const lineCf = this.prop?.metricsR?.length ? this.prop.metricsR : this.prop.lineMetrics
        const lineMetrics = lineCf?.map((item) => {
          return item.name
        }) || []

        const barCf = this.prop?.metricsL?.length ? this.prop.metricsL : this.prop.barMetrics
        const barMetrics = barCf?.map((item) => {
          return item.name
        }) || []
        let _op = this.getDimentionOption()
        if (this.option.sameyAxis) {
          let allValue = []
          _op.series.forEach((i) => {
            allValue = allValue.concat(i.data)
          })
          const max = Math.max(...allValue)
          const min = Math.min(...allValue)
          for (let i of option.yAxis) {
            i.max = max
            i.min = min
          }
        }
        const {
          categories = [],
          series = []
        } = _op
        option.legend = this.getOptionLegend(series)
        option.xAxis.data = categories
        const {
          barNumber = 1,
          lineNumber = 1
        } = this.option
        for (let i = 0; i < series.length; i++) {
          let y = series[i]
          if (lineMetrics.includes(y.name)) {
            y.type = this.getType(y.name) || 'line'
            y.yAxisIndex = barNumber > 0 ? 1 : 0
            y = {
              ...y,
              ...{
                smooth: this.validData(this.option.smooth, true),
                showSymbol: this.validData(this.option.symbolShow, false),
                symbol: this.option.symbolKind,
                symbolSize: this.option.symbolSize || 10,
                areaStyle: (() => {
                  if (this.option.areaStyle) {
                    return {
                      color: this.getColor(i),
                      opacity: 0.7
                    };
                  }
                })(),
                barWidth: this.option.barWidth || 16,
                lineStyle: {
                  width: this.option.lineWidth || 1
                },
                itemStyle: this.getHasProp(!this.switchTheme, {
                  color: this.getColor(i)
                }),
                label: this.getOptionLabel({
                  position: this.option.labelPosition,
                }),
                labelLine: {
                  show: this.option.labelContent?.includes('引导线') || false
                },
                markLine: {
                  ...this.getMarkLineDefaultSet(),
                  lineStyle: {
                    width: this.option.rightAxisMarkLineWidth || 1,
                    type: this.option.rightAxisMarkLineType,
                    color: this.option.rightAxisMarkLineColor || "#FF0000",
                  },
                  data: this.option.rightAxisMarkLineShow && this.getMarklineOption('old')
                }
              }
            }

            /**
             * @desc 临时逻辑，过滤值 null和undefined格式化为0
             * *****/
            if (y?.data && Array.isArray(y.data)) {
              y.data = y.data.map(v => isNaN(Number(v.value)) ? {...v, value: '0'} : {...v, value: Number(v.value)})
            }
            /***********************************/
            option.series.push(y)
          }
          if (barMetrics.includes(y.name)) {
            y = series[i]
            y.type = this.getType(y.name) || 'bar'
            y.yAxisIndex = 0
            y = {
              ...y,
              ...{
                stack: this.option.stack,
                barWidth: this.option.barWidth || 16,
                itemStyle: this.getHasProp(
                    !this.switchTheme,
                    {
                      color: this.getColor(i),
                    },
                    {barBorderRadius: this.option.barRadius || 0}
                ),
                label: this.getOptionLabel({
                  position: this.option.labelPosition,
                }),
                labelLine: {
                  show: this.option.labelContent?.includes('引导线') || false
                },
                markLine: {
                  ...this.getMarkLineDefaultSet(),
                  lineStyle: {
                    width: this.option.yAxisMarkLineWidth || 1,
                    type: this.option.yAxisMarkLineType,
                    color: this.option.yAxisMarkLineColor || "#FF0000",
                  },
                  data: this.option.yAxisMarkLineShow && this.getMarklineOption()
                }
              }
            }

            /**
             * @desc 临时逻辑，过滤值 null和undefined格式化为0
             * *****/
            if (y?.data && Array.isArray(y.data)) {
              y.data = y.data.map(v => isNaN(Number(v.value)) ? {...v, value: '0'} : {...v, value: Number(v.value)})
            }
            /***********************************/
            option.series.push(y)
          }
          // color
          // y.itemStyle = {
          //   color: this.getColor(i)
          // }

        }
        // 辅助指标显示在tooltip
        if (this.prop.assistMetrics && this.prop.assistMetrics.length && this.option.assistTip) {
          option.tooltip.formatter = (params) => util.assistMetricsToolFormatter(params, this.prop, this.dataChart, series)
        }
      }
      this.myChart.resize();
      console.log(option)
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
  }
};

</script>
